// extracted by css-extract-rspack-plugin
export default {"overviewTable":"_43dfa559","overviewTopRow":"_9c94d386","label":"_503d83e2"};